import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { addDownload } from '../../../handlers/downloads'
import { useNavigate } from 'react-router-dom'
import { initializeWorker } from '../../../handlers/workers'
import CsddSource from '../../../components/Modals/CsddGenerator'
import { uploadFileToS3 } from '../../../handlers/s3'

import './Tools.css'

export default function CsddGenerator() {
  const isQA = process.env.REACT_APP_NODE_ENV === 'development'
  const navigate = useNavigate()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsloading] = useState(false)
  const [inputs, setInputs] = useState({
    account: 'outdoorequipped',
    source: 'upload',
    marketplace: 'A2EUQ1WTGCTBG2',
    importName: ''
  })
  const [reports, setReports] = useState({
    all_listings: null,
    active_listings: null,
    suppressed_listings: null,
    amz_fulfilled: null,
    manage_inv: null,
    res_inv: null,
    inv_health: null,
    fee_preview: null,
    pricing_health: null,
    '30d_business': null,
    '7d_business': null,
    sc_listing_issues: null,
  })
  const [gdriveReports, setGdriveReports]= useState({
    received_inv: null,
    fba_return: null,
    sales_history: null,
  })

  const handleSelectChange = (event) => {
    const { id, value } = event.target
    setInputs(prevState => ({ ...prevState, [id]: value }))
  }

  const handleTextInputChange = (event) => {
    const { id, value } = event.target
    setInputs(prevState => ({ ...prevState, [id]: value }))
  }

  const handleSubmit = async () => {
    console.log('Form submitted with inputs:', inputs, reports, gdriveReports)
    setIsloading(true)
  
    if (inputs.importName === '') {
      toast.error('Provide import name!')
      setIsloading(false)
      return
    }
  
    const batchId = `DDT-${Date.now()}${isQA ? ' (QA)' : ''}`
    const requestBody = {
      batchId,
      category: 'csdd-generator',
      importName: inputs.importName,
      user: localStorage.getItem('email'),
      options: inputs,
    }
  
    if (inputs.source === 'upload') {
      const allReportsWereProvided = Object.values(reports).every(value => value !== null)
      const allGDriveReportsWereProvided = Object.values(gdriveReports).every(value => value !== null)

      if (!allReportsWereProvided || !allGDriveReportsWereProvided) {
        toast.error('Supply all needed amazon reports!')
        setIsloading(false)
        return
      }
  
      try {
        const uploadedReports = {}
  
        for (const [reportKey, reportFile] of Object.entries(reports)) {
          const fileNameWithReportType = `${reportKey}-${reportFile.name}`
        
          const uploadingToastId = toast(`Uploading file: ${fileNameWithReportType}`, {
            autoClose: false, 
          })
        
          try {
            const keyName = await uploadFileToS3(
              `imports/${batchId}/${fileNameWithReportType}`,
              reportFile,
              fileNameWithReportType
            )
        
            toast.success(`Done uploading file: ${fileNameWithReportType}`)
            toast.dismiss(uploadingToastId)
        
            uploadedReports[reportKey] = keyName
          } catch (error) {
            toast.error('Error uploading reports to S3')
            console.error('S3 upload error:', error)
            toast.dismiss(uploadingToastId) 
            setIsloading(false)
            return
          }
        }        
  
        requestBody.originalFile = JSON.stringify({uploadedReports, gdriveReports})
  
      } catch (error) {
        toast.error('Error uploading reports to S3')
        console.error('S3 upload error:', error)
        setIsloading(false)
        return
      }
    } else if(inputs.source === 'amazon'){
      const allGDriveReportsWereProvided = Object.values(gdriveReports).every(value => value !== null)
      if (!allGDriveReportsWereProvided) {
        toast.error('Supply all needed gdrive reports!')
        setIsloading(false)
        return
      }
      requestBody.originalFile = JSON.stringify({gdriveReports})
    }
  
    const response = await addDownload(requestBody)
    await initializeWorker(response.download)
    navigate('/downloads')
  
    toast.success('Submitted!')
    setIsloading(false)
  }  

  return (
    <React.Fragment>
      <CsddSource modalOpen={{isModalOpen, setIsModalOpen}} reportState={{reports, setReports}} gdriveReportsState={{gdriveReports, setGdriveReports}} inputs={inputs}/>
      <div className='x_card-body x_card-body2 card-body'>
        <div className='x_select-mainContainer'>
          <div className='x_select-container2'>
            <label htmlFor='account' className='x_label form-label'>Account:</label>
            <select className='x_form-select form-select' id='account' onChange={handleSelectChange} value={inputs.account}>
              <option value='outdoorequipped'>Outdoor Equipped</option>
            </select>
          </div>
        </div>
        <div className='x_select-mainContainer2 x_select-mainContainer3'>
          <div className='x_select-container2'>
            <label htmlFor='marketplace' className='x_label form-label'>Marketplace:</label>
            <select className='x_form-select form-select' id='marketplace' onChange={handleSelectChange} value={inputs.marketplace}>
              <option value='A2EUQ1WTGCTBG2'>CA</option>
              <option value='ATVPDKIKX0DER'>US</option>
            </select>
          </div>
          <div className='x_select-container2'>
            <label htmlFor='source' className='x_label form-label'>Amazon Reports Source:</label>
            <div className='x_select-container3'>
              <select className={`x_form-select ${inputs.source === 'upload' ? 'x_form-select2' : ''} form-select`} id='source' onChange={handleSelectChange} value={inputs.source}>
                <option value='upload'>Upload</option>
                <option disabled value='amazon'>Amazon</option>
              </select>
              {inputs.source === 'upload' &&
                <button id='sourceUpload' className='x_btn_upload btn btn-primary btn-sm' onClick={()=>setIsModalOpen(true)}>
                  <i className='fa-solid fa-upload'></i>
                </button>
              }
            </div>
          </div>
        </div>
        <div className='x_textInput-container'>
          <label className='x_label form-label'>Import Name: </label>
          <input type='text' className='x_outputFile form-control' placeholder='Please input desired file name' id='importName' onChange={handleTextInputChange}/>
        </div>
      </div>
      <div className='x_card-footer card-footer'>
        <button id='parseButton1' className='x_btn btn btn-primary btn-sm'
          onClick={handleSubmit}
          disabled
          // disabled={isLoading ? true : false}
        >{isLoading ? <i className="fa-solid fa-spinner fa-spin-pulse"></i> : 'Submit'}</button>
      </div>
    </React.Fragment>
  )
}